import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f45d02f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-preview-confirm-delete-popover__target" }
const _hoisted_2 = { class: "file-preview-confirm-delete-popover__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-preview-confirm-delete-popover__title" }, " Удалить документ? ", -1))
const _hoisted_4 = { class: "file-preview-confirm-delete-popover__buttons" }

import { PopoverPositionEnum, TirPmPopover } from "tir-pm-popover";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'file-preview-confirm-delete-popover',
  props: {
  /**Открыт ли поповер */
  isOpened: {
    type: Boolean,
    default: false,
  },
  /**Загрузка */
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickDelete", "update:isOpened"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





/**Ссылка на элемент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();

const close = () => $popover.value?.close();
const open = () => $popover.value?.open();

__expose({
  close,
  open,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    classes: "file-preview-confirm-delete-popover",
    ref_key: "$popover",
    ref: $popover,
    position: _unref(PopoverPositionEnum).Top,
    onOpen: _cache[1] || (_cache[1] = ($event: any) => (emit('update:isOpened', true))),
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('update:isOpened', false)))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(TirPmButton), {
            size: _unref(TirPmButtonSizeEnum).Small,
            variant: _unref(TirPmButtonVariantEnum).PrimaryState,
            "is-disabled": __props.isLoading,
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Отмена ")
            ]),
            _: 1
          }, 8, ["size", "variant", "is-disabled"]),
          _createVNode(_unref(TirPmButton), {
            size: _unref(TirPmButtonSizeEnum).Small,
            variant: _unref(TirPmButtonVariantEnum).SecondaryState,
            "is-loading": __props.isLoading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onClickDelete')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Удалить ")
            ]),
            _: 1
          }, 8, ["size", "variant", "is-loading"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["position"]))
}
}

})